module.exports = __webpack_public_path__ + "img/apple.95de7cd0.png";